<template>
	<section>
		<v-form ref="formActual">
			<v-simple-table>
				<thead>
					<tr>
						<th>Fecha</th>
						<th>01/02/2022</th>
						<th>01/02/2022</th>
						<th>01/02/2022</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							Peso actual:
						</td>
						<td>
							<v-text-field
								:rules="[
									!!valor.PesoActual || 'Campo Obligatorio'
								]"
								v-model="valor.PesoActual"
								type="number"
								suffix="kg"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							¿Se encuentra en diálisis?
						</td>
						<td>
							<v-radio-group
								v-model="valor.EnDialisis"
								hide-details="auto"
								row
								mandatory
								class="ma-0 pa-0 pr-4 pt-1"
							>
								<v-radio label="Sí" :value="true"></v-radio>
								<v-radio label="No" :value="false"></v-radio>
							</v-radio-group>
						</td>
					</tr>
					<tr>
						<td>
							Peso prediálisis:
						</td>
						<td>
							<v-text-field
								:rules="[
									!valor.EnDialisis ||
										!!valor.PesoPredialisis ||
										'Campo Obligatorio'
								]"
								v-model="valor.PesoPredialisis"
								type="number"
								:disabled="!valor.EnDialisis"
								suffix="kg"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Peso postdiálisis:
						</td>
						<td>
							<v-text-field
								:rules="[
									!valor.EnDialisis ||
										!!valor.PesoPostdialisis ||
										'Campo Obligatorio'
								]"
								v-model="valor.PesoPostdialisis"
								type="number"
								:disabled="!valor.EnDialisis"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Peso seco:
						</td>
						<td>
							<v-text-field
								:rules="[
									!!valor.PesoSeco || 'Campo Obligatorio'
								]"
								v-model="valor.PesoSeco"
								type="number"
								suffix="kg"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Talla:
						</td>
						<td>
							<v-text-field
								:rules="[!!valor.TallaM || 'Campo Obligatorio']"
								v-model="valor.TallaM"
								type="number"
								suffix="m"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Talla:
						</td>
						<td>
							<v-text-field
								suffix="cm"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
								solo
								readonly
								:value="valor.TallaCm"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							IMC:
						</td>
						<td>
							<v-text-field
								hide-details="auto"
								suffix="kg/m2"
								class="ma-0 pa-0 pr-4 pt-1"
								solo
								readonly
								:value="valor.Imc"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Interpretación IMC:
						</td>
						<td>
							<v-text-field
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
								solo
								readonly
								:value="valor.InterpretacionImc"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Peso habitual
						</td>
						<td>
							<v-text-field
								:rules="[
									!!valor.PesoHabitual || 'Campo Obligatorio'
								]"
								v-model="valor.PesoHabitual"
								type="number"
								suffix="kg"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							% Peso Habitual:
						</td>
						<td>
							<v-text-field
								suffix="%"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
								solo
								readonly
								:value="valor.PorcentajePesoHabitual"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Interpretación % de peso habitual:
						</td>
						<td>
							<v-text-field
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
								solo
								readonly
								:value="valor.InterpretacionPesoHabitual"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							% pérdida de peso:
						</td>
						<td>
							<v-text-field
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
								solo
								readonly
								suffix="%"
								:value="valor.PorcentajePerdidaPeso"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Interpretación % de pérdida de peso:
						</td>
						<td>
							<v-autocomplete
								:rules="[
									!!valor.InterpretacionPerdidaPeso ||
										'Campo Obligatorio'
								]"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
								v-model="valor.InterpretacionPerdidaPeso"
								:items="catalogos.InterpretacionesPerdidaPeso"
								return-object
								item-text="Descripcion"
							></v-autocomplete>
						</td>
					</tr>
					<tr>
						<td>
							Peso ideal o recomendado:
						</td>
						<td>
							<v-text-field
								:rules="[
									!!valor.PesoIdeal || 'Campo Obligatorio'
								]"
								v-model="valor.PesoIdeal"
								type="number"
								suffix="kg"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							% peso ideal:
						</td>
						<td>
							<v-text-field
								suffix="%"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
								solo
								readonly
								:value="valor.PorcentajePesoIdeal"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Interpretación % de peso ideal:
						</td>
						<td>
							<v-text-field
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
								solo
								readonly
								:value="valor.InterpretacionPesoIdeal"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Peso ajustado libre de edema:
						</td>
						<td>
							<v-text-field
								suffix="kg"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
								solo
								readonly
								:value="valor.PesoAustadoLibreEdema"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Circunferencia de cintura :
						</td>
						<td>
							<v-text-field
								:rules="[
									!!valor.CircunferenciaCintura ||
										'Campo Obligatorio'
								]"
								v-model="valor.CircunferenciaCintura"
								type="number"
								suffix="cm"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Circunferencia de cadera:
						</td>
						<td>
							<v-text-field
								:rules="[
									!!valor.CircunferenciaCadera ||
										'Campo Obligatorio'
								]"
								v-model="valor.CircunferenciaCadera"
								type="number"
								suffix="cm"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Índice Cintura-Cadera:
						</td>
						<td>
							<v-text-field
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
								solo
								readonly
								:value="valor.IndiceCinturaCadera"
							></v-text-field>
						</td>
					</tr>
					<tr>
						<td>
							Amputaciones
						</td>
						<td>
							<v-radio-group
								hide-details="auto"
								row
								mandatory
								v-model="valor.Amputaciones"
								class="ma-0 pa-0 pr-4 pt-1"
							>
								<v-radio label="Sí" :value="true"></v-radio>
								<v-radio label="No" :value="false"></v-radio>
							</v-radio-group>
						</td>
					</tr>
					<tr v-if="valor.Amputaciones">
						<td>
							%/Kg de amputación:
						</td>
						<td>
							<v-text-field
								:rules="[
									!!valor.CantidadAmputacion ||
										'Campo Obligatorio'
								]"
								v-model="valor.CantidadAmputacion"
								type="number"
								hide-details="auto"
								class="ma-0 pa-0 pr-4 pt-1"
							></v-text-field>
						</td>
					</tr>
				</tbody>
			</v-simple-table>
		</v-form>
		<v-footer app class="pt-3 d-print-none">
			<v-btn color="secondary" x-large @click.prevent="regresar"
				>Regresar <v-icon>chevron_left</v-icon></v-btn
			>
			<v-spacer></v-spacer>
			<v-btn color="primary" x-large @click.prevent="guardar"
				><v-icon>save</v-icon> Guardar
			</v-btn>
		</v-footer>
	</section>
</template>

<script>
import ServicioVisita from "../../../services/visita";
export default {
	name: "antropometria",
	data() {
		return {
			valor: {},
			catalogos: {}
		};
	},
	async mounted() {
		this.obtenerCatalogos();
		await this.obtenerInfoPaso();
	},
	methods: {
		async obtenerInfoPaso() {
			const res = await ServicioVisita.obtenerInfoPaso(
				"Antropometria",
				this.visitaId
			);
			if (res.data.result === 1 && res.data.data.Table0.length) {
				const valor = JSON.parse(
					res.data.data.Table0[0].Antroprometria
				);
				if (valor) this.valor = valor;
			}
		},
		async guardar() {
			if (this.$refs.formActual.validate()) {
				const res = await ServicioVisita.guardarAntropometria(
					this.visitaId,
					this.valor
				);
				if (res.data.result === 1) {
					this.$router.back();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			} else {
				this.$root.mensajeError =
					"Por favor llene los campos requeridos.";
			}
		},
		regresar() {
			this.$router.back();
		},
		obtenerCatalogos() {
			this.catalogos.InterpretacionesPerdidaPeso = this.$root.generarCatalogo(
				["Sin Pérdida", "Pérdida Significativa", "Pérdida Grave"]
			);
		},
		actualizarFormulas() {
			this.valor.Imc = this.$root.formulas.indiceMasaCorporal(
				this.valor.PesoSeco,
				this.valor.TallaM
			);
			if (this.valor.TallaM) {
				this.valor.TallaCm = this.valor.TallaM * 100;
			}
			this.valor.InterpretacionImc = this.$root.formulas.interpretacionIMC(
				this.valor.Imc
			);
			this.valor.PorcentajePesoHabitual = this.$root.formulas.ptgPesoHabitual(
				this.valor.PesoSeco,
				this.valor.PesoHabitual
			);
			this.valor.InterpretacionPesoHabitual = this.$root.formulas.interpretacionPesoHabitual(
				this.valor.PorcentajePesoHabitual
			);
			this.valor.PorcentajePerdidaPeso = this.$root.formulas.ptgPerdidaPeso(
				this.valor.PesoHabitual,
				this.valor.PesoSeco,
				this.valor.PorcentajePesoHabitual
			);
			this.valor.PorcentajePesoIdeal = this.$root.formulas.ptgPesoIdeal(
				this.valor.PesoSeco,
				this.valor.PesoIdeal
			);
			this.valor.InterpretacionPesoIdeal = this.$root.formulas.interpretacionPesoIdeal(
				this.valor.PorcentajePesoIdeal
			);
			this.valor.PesoAustadoLibreEdema = this.$root.formulas.pesoAjustadoLibreEdema(
				this.valor.PesoSeco,
				this.valor.PesoIdeal
			);
			this.valor.IndiceCinturaCadera = this.$root.formulas.indiceCinturaCadera(
				this.valor.CircunferenciaCintura,
				this.valor.CircunferenciaCadera
			);
		}
	},
	watch: {
		valor: {
			deep: true,
			handler() {
				this.actualizarFormulas();
			}
		},

		datos() {
			if (this.datos) {
				this.valor = JSON.parse(this.datos);
			}
		}
	},
	computed: {
		visitaId() {
			return this.$route.params.visitaId;
		}
	}
};
</script>
